<template>
  <div class="row">
    <div class="col-md-4 offset-md-4">
      <form v-on:submit.prevent="onSubmit">
        <div class="form-group">
          <label for="login_email">Email:</label>
          <input
            id="login_email"
            class="form-control"
            type="email"
            v-model="email"
            placeholder="Email"
            required
          />
        </div>
        <div class="form-group">
          <label for="login_email">Password:</label>
          <input
            id="login_password"
            class="form-control"
            type="password"
            v-model="password"
            placeholder="Password"
            required
          />
        </div>
        <input type="submit" class="btn btn-primary" value="Sign In"/>
      </form>
    </div>
  </div>
</template>

<script>
import AuthenticationService from '@/common/services/authentication.service';

export default {
  name: 'Login',
  data() {
    return {
      email: null,
      password: null,
      error: null,
    };
  },
  methods: {
    onSubmit() {
      AuthenticationService.login(this.email, this.password)
        .then(() => {
          this.$router.push({ path: '/' }, () => {
            Vue.notify({
              title: 'Success',
              text: 'Successful login!',
              type: 'success',
              width: 400,
            });
          });
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            this.$notify({
              type: 'error',
              title: 'Invalid credentials',
              text: error.response.data.error,
              width: 400,
            });
          }
        });
    },
  },
};
</script>
